import _ from 'lodash'

export function get(object: any, path: any, defaultValue?: any): any {
  return _.get(object, path, defaultValue)
}

export function equal(value: any, other: any): any {
  return _.isEqual(value, other)
}

export function cloneDeep(value: any): any {
  return _.cloneDeep(value)
}

export function keys(object?: any): any {
  return _.keys(object)
}

export function values(object: any): any {
  return _.values(object)
}

export function defaultTo(value: any, defaultValue: any): any {
  return _.defaultTo(value, defaultValue)
}

export function isNumber(value: any): boolean {
  return _.isNumber(value)
}

export function isString(value: any): boolean {
  return _.isString(value)
}

export function isNil(value: any): boolean {
  return _.isNil(value)
}

export function isNull(value: any): boolean {
  return _.isNull(value)
}

export function isUndefined(value: any): boolean {
  return _.isUndefined(value)
}

export function isEmpty(value: any): boolean {
  return _.isEmpty(value)
}

export function isArray(value: any): boolean {
  return _.isArray(value)
}

export function _if(cond: any, value_if_true: any, value_if_false: any): any {
  return cond ? value_if_true : value_if_false
}

export function stringify(value: any, replacer?: any, space?: string | number): string {
  return JSON.stringify(value, replacer, space)
}

export function matchesProperty(path: any, srcValue: any): any {
  return _.matchesProperty(path, srcValue)
}
